import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useInstituteList(data = {}) {
  const { enabled = false, queryParams = '' } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getInstituteList() {
    return privateFetch.get(`/v1/admin/institute${queryParams}`).then((res) => res.data);
  }

  return useQuery(['institute-lists', { data }], getInstituteList, {
    enabled,
    keepPreviousData: true,
  });
}

export default useInstituteList;
